import React from 'react';

/**
 * DataOps Lineage Help Content
 */
const LineageHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Data Lineage
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Data Lineage provides an interactive visualization of how data flows through your organization. Understand data origins, transformations, and dependencies to ensure data quality and compliance.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Lineage Graph
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Navigate the interactive lineage visualization:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Zoom &amp; Pan</span>: Use mouse scroll to zoom and drag to pan across the graph</p>
          <p>&#8226; <span className="font-medium">Node selection</span>: Click any node to see its details and connections</p>
          <p>&#8226; <span className="font-medium">Expand/Collapse</span>: Double-click nodes to expand or collapse branches</p>
          <p>&#8226; <span className="font-medium">Search</span>: Find specific assets within the lineage view</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Upstream Lineage
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Trace where your data originates:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Source systems</span>: Identify the original data sources</p>
          <p>&#8226; <span className="font-medium">Transformation chain</span>: See all processing steps applied to the data</p>
          <p>&#8226; <span className="font-medium">Data quality</span>: Understand how upstream issues may affect your data</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Downstream Lineage
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Understand what depends on your data:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Consumer assets</span>: See all tables and views that use this data</p>
          <p>&#8226; <span className="font-medium">Reports &amp; Dashboards</span>: Identify BI assets consuming the data</p>
          <p>&#8226; <span className="font-medium">Impact scope</span>: Understand the reach of potential changes</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Column-Level Lineage
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Field mapping</span>: Track how individual columns flow between assets</p>
          <p>&#8226; <span className="font-medium">Transformation logic</span>: View SQL or transformation expressions</p>
          <p>&#8226; <span className="font-medium">Sensitive data tracking</span>: Follow PII and sensitive fields through the pipeline</p>
        </div>
      </div>

    </>
  );
};

export default LineageHelp;
